﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
// State
//-------------------------------------------------------------------------------------

type UpdateError = { type: "setError"; errorMessage: string };
type SetLoading = { type: "setLoading" };
type SetVerified = { type: "setVerified" };
type Navigate = { type: "navigate"; uri: string };

export type ConfirmPageViewAction =
    | UpdateError
    | SetLoading
    | SetVerified
    | Navigate;

interface ConfirmPageState {
    loading: boolean;
    isVerified: boolean;
    errorMessage: string;
    navigateUri?: string;
}

export function reducer(
    state: ConfirmPageState,
    action: ConfirmPageViewAction
): ConfirmPageState {
    switch (action.type) {
        case "setError": {
            return {
                ...state,
                errorMessage: action.errorMessage,
                loading: false,
            };
        }
        case "setLoading": {
            return { ...state, errorMessage: null, loading: true };
        }
        case "setVerified": {
            return {
                ...state,
                errorMessage: null,
                loading: false,
                isVerified: true,
            };
        }
        case "navigate": {
            return { ...state, loading: true, navigateUri: action.uri };
        }
    }
}
